// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Application Stats Styles
 * Styles for the application statistics component
 */

.application-stats {
  margin-bottom: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.stats-header {
  padding: 1.5rem;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.stats-header h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.25rem;
  font-weight: 600;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  padding: 1.5rem;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  border-radius: 8px;
  background: #f8f9fa;
  border-left: 4px solid #0D3B66;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.stat-card.total {
  border-left-color: #0D3B66;
}

.stat-card.pending {
  border-left-color: #ffc107;
}

.stat-card.approved {
  border-left-color: #28a745;
}

.stat-card.rejected {
  border-left-color: #dc3545;
}

.stat-icon {
  font-size: 2rem;
  opacity: 0.8;
}

.stat-content {
  flex: 1 1;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1;
  margin-bottom: 0.25rem;
}

.stat-label {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.stat-percentage {
  font-size: 0.75rem;
  color: #6c757d;
  font-weight: 600;
}

.stats-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  padding: 1.5rem;
  background: #fafafa;
  border-top: 1px solid #dee2e6;
}

.stat-section {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-section h4 {
  margin: 0 0 1rem 0;
  color: #2c3e50;
  font-size: 1rem;
  font-weight: 600;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0.5rem;
}

.state-list,
.monthly-trend {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.state-item,
.month-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #0D3B66;
}

.state-name,
.month-name {
  font-weight: 500;
  color: #495057;
  font-size: 0.875rem;
}

.state-count,
.month-count {
  font-weight: 600;
  color: #0D3B66;
  font-size: 0.875rem;
  background: #FFF7ED;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.75rem;
    padding: 1rem;
  }

  .stat-card {
    padding: 1rem;
    gap: 0.75rem;
  }

  .stat-icon {
    font-size: 1.5rem;
  }

  .stat-value {
    font-size: 1.5rem;
  }

  .stats-details {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1rem;
  }

  .stat-section {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .stats-header {
    padding: 1rem;
  }

  .stats-header h3 {
    font-size: 1.125rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    padding: 0.75rem;
  }

  .stat-card {
    padding: 0.75rem;
  }

  .stat-icon {
    font-size: 1.25rem;
  }

  .stat-value {
    font-size: 1.25rem;
  }

  .stat-label {
    font-size: 0.8125rem;
  }

  .stat-percentage {
    font-size: 0.6875rem;
  }

  .stats-details {
    padding: 0.75rem;
  }

  .stat-section {
    padding: 0.75rem;
  }

  .state-item,
  .month-item {
    padding: 0.5rem;
  }

  .state-name,
  .month-name {
    font-size: 0.8125rem;
  }

  .state-count,
  .month-count {
    font-size: 0.8125rem;
    padding: 0.125rem 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/applications/ApplicationStats.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,2DAA2D;IAC3D,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;;IAEE,oBAAoB;IACpB,wBAAwB;EAC1B;AACF","sourcesContent":["/**\n * Application Stats Styles\n * Styles for the application statistics component\n */\n\n.application-stats {\n  margin-bottom: 1.5rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.stats-header {\n  padding: 1.5rem;\n  background: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.stats-header h3 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  padding: 1.5rem;\n}\n\n.stat-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  border-radius: 8px;\n  background: #f8f9fa;\n  border-left: 4px solid #0D3B66;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.stat-card.total {\n  border-left-color: #0D3B66;\n}\n\n.stat-card.pending {\n  border-left-color: #ffc107;\n}\n\n.stat-card.approved {\n  border-left-color: #28a745;\n}\n\n.stat-card.rejected {\n  border-left-color: #dc3545;\n}\n\n.stat-icon {\n  font-size: 2rem;\n  opacity: 0.8;\n}\n\n.stat-content {\n  flex: 1;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2c3e50;\n  line-height: 1;\n  margin-bottom: 0.25rem;\n}\n\n.stat-label {\n  font-size: 0.875rem;\n  color: #6c757d;\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n\n.stat-percentage {\n  font-size: 0.75rem;\n  color: #6c757d;\n  font-weight: 600;\n}\n\n.stats-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  padding: 1.5rem;\n  background: #fafafa;\n  border-top: 1px solid #dee2e6;\n}\n\n.stat-section {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.stat-section h4 {\n  margin: 0 0 1rem 0;\n  color: #2c3e50;\n  font-size: 1rem;\n  font-weight: 600;\n  border-bottom: 2px solid #e9ecef;\n  padding-bottom: 0.5rem;\n}\n\n.state-list,\n.monthly-trend {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.state-item,\n.month-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border-left: 3px solid #0D3B66;\n}\n\n.state-name,\n.month-name {\n  font-weight: 500;\n  color: #495057;\n  font-size: 0.875rem;\n}\n\n.state-count,\n.month-count {\n  font-weight: 600;\n  color: #0D3B66;\n  font-size: 0.875rem;\n  background: #FFF7ED;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 0.75rem;\n    padding: 1rem;\n  }\n\n  .stat-card {\n    padding: 1rem;\n    gap: 0.75rem;\n  }\n\n  .stat-icon {\n    font-size: 1.5rem;\n  }\n\n  .stat-value {\n    font-size: 1.5rem;\n  }\n\n  .stats-details {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .stat-section {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .stats-header {\n    padding: 1rem;\n  }\n\n  .stats-header h3 {\n    font-size: 1.125rem;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n    padding: 0.75rem;\n  }\n\n  .stat-card {\n    padding: 0.75rem;\n  }\n\n  .stat-icon {\n    font-size: 1.25rem;\n  }\n\n  .stat-value {\n    font-size: 1.25rem;\n  }\n\n  .stat-label {\n    font-size: 0.8125rem;\n  }\n\n  .stat-percentage {\n    font-size: 0.6875rem;\n  }\n\n  .stats-details {\n    padding: 0.75rem;\n  }\n\n  .stat-section {\n    padding: 0.75rem;\n  }\n\n  .state-item,\n  .month-item {\n    padding: 0.5rem;\n  }\n\n  .state-name,\n  .month-name {\n    font-size: 0.8125rem;\n  }\n\n  .state-count,\n  .month-count {\n    font-size: 0.8125rem;\n    padding: 0.125rem 0.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
